// import React, { useState, useEffect } from "react";
// import EditIcon from "../../Assets/Images/CommanImages/GPenz.png";
// import { set } from "date-fns";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import { use } from "react";

// const UserSettings = ({ setPagePath, dataClient }) => {
//   const [activeTab, setActiveTab] = useState("visitor");
//   const [appSettings, setAppSettings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [editValue, setEditValue] = useState("");
//   const [editComments, setEditComments] = useState("");
//   const [saving, setSaving] = useState(false);

//   const [editError, setEditError] = useState("");

//   useEffect(() => {
//     setPagePath("Settings");
//   }, []);

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ?? null;
//   const user_name = dataClient?.client_schema_name?.[6]?.[0]?.user_name ?? null;

//   useEffect(() => {
//     if (activeTab === "app") {
//       fetchAppSettings();
//     }
//   }, [activeTab]);

//   const fetchAppSettings = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-branch-app-settings?client_branch_id=${clientBranchId}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
//       if (result.status === 200) {
//         setAppSettings(result.data);
//       }
//     } catch (error) {
//       console.error("Error fetching settings:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (setting) => {
//     setEditingId(setting.key_id);
//     setEditValue(setting.value || "");
//     setEditComments("");
//   };

//   const handleCancelEdit = () => {
//     setEditingId(null);
//     setEditValue("");
//     setEditComments("");
//   };

//   const handleSave = async (setting) => {
//     console.log();
//     setSaving(true);
//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/update-branch-app-settings`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             accept: "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify([
//             {
//               client_id: 1,
//               client_branch_id: 1,
//               key_id: setting.key_id,
//               value: editValue,
//               comments_: editComments,
//               username: user_name,
//             },
//           ]),
//         }
//       );

//       if (response.ok) {
//         setAppSettings((prev) =>
//           prev.map((s) =>
//             s.key_id === setting.key_id ? { ...s, value: editValue } : s
//           )
//         );
//         setEditingId(null);
//         setEditValue("");
//         setEditComments("");
//       }
//     } catch (error) {
//       console.error("Error saving setting:", error);
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         .tab-button-us {
//           background: none;
//           border: none;
//           padding: 16px 8px;
//           font-size: 17px;
//           font-weight: 500;
//           cursor: pointer;
//           border-bottom: 2px solid transparent;
//           transition: all 0.3s;
//           color: #666;
//         }
//         .tab-button-us.active {
//           // color: #f97316;
//           color: #666;
//           // border-bottom-color: #f97316;
//           border-bottom-color: #ffbd20;
//         }
//         .tab-button-us:hover:not(.active) {
//           color: #333;
//         }
//         .setting-card {
//           background-color: #f3f4f6;
//           border: 1px solid #d1d5db;
//           border-radius: 8px;
//           padding: 24px;
//           margin-bottom: 16px;
//         }
//         .input-field {
//           width: 100%;
//           background-color: white;
//           border: 1px solid #d1d5db;
//           border-radius: 4px;
//           padding: 8px 12px;
//           font-size: 14px;
//           color: #1f2937;
//         }
//         .input-field:focus {
//           outline: none;
//           border-color: #f97316;
//           box-shadow: 0 0 0 1px #f97316;
//         }
//         .btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 8px 16px;
//           border: none;
//           border-radius: 4px;
//           font-size: 14px;
//           cursor: pointer;
//           transition: background-color 0.3s;
//           font-weight: 500;
//         }
//         .btn-save {
//           background-color: #f97316;
//           color: white;
//         }
//         .btn-save:hover:not(:disabled) {
//           background-color: #ea580c;
//         }
//         .btn-cancel {
//           background-color: #d1d5db;
//           color: #1f2937;
//         }
//         .btn-cancel:hover:not(:disabled) {
//           background-color: #9ca3af;
//         }
//         .btn:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
//         .edit-btn {
//           background: none;
//           border: 1px solid #f97316;
//           padding: 6px 12px;
//           border-radius: 4px;
//           cursor: pointer;
//           color: #f97316;
//           transition: all 0.3s;
//           font-size: 13px;
//           font-weight: 500;
//         }
//         .edit-btn:hover:not(:disabled) {
//           background-color: #f97316;
//           color: white;
//         }
//         .edit-btn:disabled {
//           border-color: #9ca3af;
//           color: #9ca3af;
//           cursor: not-allowed;
//         }
//       `}</style>

//       {/* Header */}
//       <div style={styles.header}>
//         <div style={styles.headerContent}>
//           <button
//             onClick={() => setActiveTab("visitor")}
//             className={`tab-button-us ${
//               activeTab === "visitor" ? "active" : ""
//             }`}
//           >
//             USER SETTINGS
//           </button>
//           <button
//             onClick={() => setActiveTab("app")}
//             className={`tab-button-us ${activeTab === "app" ? "active" : ""}`}
//           >
//             APP SETTINGS
//           </button>
//         </div>
//       </div>

//       {/* Content */}
//       <div style={styles.content}>
//         {activeTab === "visitor" ? (
//           <div style={styles.emptyState}>
//             <p>User settings coming soon...</p>
//           </div>
//         ) : (
//           <div>
//             {loading ? (
//               <div style={styles.emptyState}>
//                 <p>Loading settings...</p>
//               </div>
//             ) : (
//               appSettings.map((setting) => (
//                 <div key={setting.key_id} className="setting-card">
//                   <div style={styles.cardContent}>
//                     <div style={styles.cardLeft}>
//                       <h3 style={styles.cardTitle}>
//                         {setting.key_description}
//                       </h3>
//                       <p style={styles.cardSubtitle}>{setting.key_comments}</p>

//                       {editingId === setting.key_id ? (
//                         <div style={styles.editContainer}>
//                           <div style={styles.inputGroup}>
//                             <label style={styles.label}>Value</label>
//                             {/* <input
//                               type="text"
//                               value={editValue}
//                               onChange={(e) => setEditValue(e.target.value)}
//                               className="input-field"
//                               placeholder="Enter value"
//                             /> */}
//                             <input
//                               type="text"
//                               value={editValue}
//                               onChange={(e) => {
//                                 setEditValue(e.target.value);
//                                 if (
//                                   e.target.value &&
//                                   e.target.value.toString().trim() !== ""
//                                 )
//                                   setEditError("");
//                               }}
//                               onBlur={() => {
//                                 if (
//                                   !editValue ||
//                                   editValue.toString().trim() === ""
//                                 )
//                                   setEditError("Value cannot be blank");
//                               }}
//                               className="input-field"
//                             />
//                             {editError && (
//                               <div style={{ color: "#b91c1c", marginTop: 8 }}>
//                                 {editError}
//                               </div>
//                             )}
//                           </div>
//                           <div style={styles.inputGroup}>
//                             <label style={styles.label}>Comments</label>
//                             <textarea
//                               value={editComments}
//                               onChange={(e) => setEditComments(e.target.value)}
//                               className="input-field"
//                               rows="3"
//                               placeholder="Add your comments..."
//                               style={{ resize: "none" }}
//                             />
//                           </div>
//                           <div style={styles.buttonGroup}>
//                             <button
//                               onClick={() => handleSave(setting)}
//                               disabled={saving}
//                               // className="btn btn-save"
//                               className="create-test-section-btn"
//                               style={{ marginLeft: "0px", marginRight: "0px" }}
//                             >
//                               {/* {saving ? 'Saving...' : 'Save'} */}
//                               {saving ? "SAVING..." : "SAVE"}
//                             </button>
//                             <button
//                               onClick={handleCancelEdit}
//                               disabled={saving}
//                               // className="btn btn-cancel"
//                               className="create-test-section-btn"
//                               style={{ marginLeft: "0px", marginRight: "0px" }}
//                             >
//                               CANCEL
//                             </button>
//                           </div>
//                         </div>
//                       ) : (
//                         <div style={styles.valueDisplay}>
//                           <span style={styles.valueLabel}>Value: </span>
//                           {setting.value || (
//                             <span style={styles.noValue}>Not set</span>
//                           )}
//                         </div>
//                       )}
//                     </div>

//                     {editingId !== setting.key_id &&
//                       setting.edit_flag !== 0 && (
//                         <span
//                           onClick={() => handleEdit(setting)}
//                           title={
//                             setting.edit_flag === 1
//                               ? "Edit setting"
//                               : "Editing disabled"
//                           }
//                         >
//                           <img src={EditIcon} alt="Edit" />
//                         </span>
//                       )}
//                   </div>

//                   {setting.last_modified_by && (
//                     <div style={styles.metadata}>
//                       Last modified by {setting.last_modified_by} on{" "}
//                       {setting.last_modified_date}
//                     </div>
//                   )}
//                 </div>
//               ))
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: "100vh",
//     backgroundColor: "white",
//     color: "#1f2937",
//     paddingLeft: "40px",
//   },
//   header: {
//     borderBottom: "1px solid #d1d5db",
//   },
//   headerContent: {
//     maxWidth: "1200px",
//     // margin: '0 auto',
//     // padding: '0 24px',
//     display: "flex",
//     gap: "32px",
//   },
//   content: {
//     maxWidth: "1200px",
//     // margin: '0 auto',
//     // padding: '32px 24px',
//     paddingTop: "30px",
//     paddingLeft: "20px",
//   },
//   emptyState: {
//     textAlign: "center",
//     color: "#6b7280",
//     padding: "48px 0",
//   },
//   cardContent: {
//     display: "flex",
//     alignItems: "flex-start",
//     justifyContent: "space-between",
//   },
//   cardLeft: {
//     flex: 1,
//   },
//   cardTitle: {
//     fontSize: "18px",
//     fontWeight: "500",
//     color: "#1f2937",
//     marginBottom: "8px",
//   },
//   cardSubtitle: {
//     fontSize: "14px",
//     color: "#6b7280",
//     marginBottom: "16px",
//   },
//   editContainer: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },
//   inputGroup: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "8px",
//   },
//   label: {
//     fontSize: "14px",
//     fontWeight: "500",
//     color: "#374151",
//   },
//   buttonGroup: {
//     display: "flex",
//     gap: "12px",
//   },
//   valueDisplay: {
//     fontSize: "14px",
//     color: "#374151",
//   },
//   valueLabel: {
//     fontWeight: "500",
//   },
//   noValue: {
//     color: "#9ca3af",
//     fontStyle: "italic",
//   },
//   metadata: {
//     marginTop: "16px",
//     paddingTop: "16px",
//     borderTop: "1px solid #d1d5db",
//     fontSize: "12px",
//     color: "#6b7280",
//   },
// };

// export default UserSettings;
















import React, { useState, useEffect, useCallback } from 'react';
import EditIcon from '../../Assets/Images/CommanImages/GPenz.png';
import { FULL_API_BASE_URL } from "../../Config/Config";

const UserSettings = ({ setPagePath, dataClient }) => {
  const [activeTab, setActiveTab] = useState('visitor');
  const [appSettings, setAppSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editRows, setEditRows] = useState({});
  const [editError, setEditError] = useState('');
  const [saving, setSaving] = useState(false);

  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ?? null;
  const user_name = dataClient?.client_schema_name?.[6]?.[0]?.user_name ?? null;

  useEffect(() => {
    setPagePath('Settings');
  }, []);

  const fetchAppSettings = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('other');
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-branch-app-settings?client_branch_id=${clientBranchId}`,
        { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      const result = await res.json();
      if (result.status === 200) setAppSettings(result.data);
    } catch (err) {
      console.error('Error fetching settings:', err);
    } finally {
      setLoading(false);
    }
  }, [clientBranchId]);

  useEffect(() => {
    if (activeTab === 'app') fetchAppSettings();
  }, [activeTab, fetchAppSettings]);

  // ── Edit handlers ──────────────────────────────────────────────────────────
  const handleEdit = (setting) => {
    setEditingId(setting.key_id);
    setEditError('');
    if (!setting.has_sub_settings) {
      setEditRows({ 0: { value: setting.value || '', comments_: setting.comments_ || '' } });
    } else {
      const rows = {};
      setting.sub_settings.forEach(ss => {
        rows[ss.sub_key_id] = { value: ss.value || '', comments_: ss.comments_ || '' };
      });
      setEditRows(rows);
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditRows({});
    setEditError('');
  };

  const handleRowChange = (rowKey, field, val) => {
    setEditRows(prev => ({
      ...prev,
      [rowKey]: { ...prev[rowKey], [field]: val },
    }));
    if (field === 'value' && val.trim() !== '') setEditError('');
  };

  // ── Save ───────────────────────────────────────────────────────────────────
  const handleSave = async (setting) => {
    const hasBlank = Object.values(editRows).some(r => !r.value || r.value.trim() === '');
    if (hasBlank) { setEditError('Value cannot be blank'); return; }

    setSaving(true);
    try {
      const token = localStorage.getItem('other');
      let payload;

      if (!setting.has_sub_settings) {
        payload = [{
          client_id: 1,
          client_branch_id: clientBranchId,
          key_id: setting.key_id,
          value: editRows[0].value,
          comments_: editRows[0].comments_,
          username: user_name,
        }];
      } else {
        payload = setting.sub_settings.map(ss => ({
          client_branch_id: clientBranchId,
          key_id: setting.key_id,
          sub_key_id: ss.sub_key_id,
          value: editRows[ss.sub_key_id]?.value ?? ss.value,
          comments_: editRows[ss.sub_key_id]?.comments_ ?? ss.comments_,
          username: user_name,
        }));
      }

      const res = await fetch(
        `${FULL_API_BASE_URL}/update-branch-app-settings`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        setAppSettings(prev => prev.map(s => {
          if (s.key_id !== setting.key_id) return s;
          if (!setting.has_sub_settings) {
            return { ...s, value: editRows[0].value, comments_: editRows[0].comments_ };
          } else {
            return {
              ...s,
              sub_settings: s.sub_settings.map(ss => ({
                ...ss,
                value: editRows[ss.sub_key_id]?.value ?? ss.value,
                comments_: editRows[ss.sub_key_id]?.comments_ ?? ss.comments_,
              })),
            };
          }
        }));
        setEditingId(null);
        setEditRows({});
        setEditError('');
      }
    } catch (err) {
      console.error('Error saving setting:', err);
    } finally {
      setSaving(false);
    }
  };

  const isEditing = (key_id) => editingId === key_id;

  return (
    <div style={styles.container}>
      <style>{css}</style>

      {/* Tabs */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <button
            onClick={() => setActiveTab('visitor')}
            className={`tab-button-us ${activeTab === 'visitor' ? 'active' : ''}`}
          >
            USER SETTINGS
          </button>
          <button
            onClick={() => setActiveTab('app')}
            className={`tab-button-us ${activeTab === 'app' ? 'active' : ''}`}
          >
            APP SETTINGS
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={styles.content}>
        {activeTab === 'visitor' ? (
          <div style={styles.emptyState}>
            <p>User settings coming soon...</p>
          </div>
        ) : loading ? (
          <div style={styles.emptyState}>
            <p>Loading settings...</p>
          </div>
        ) : (
          appSettings.map((setting) => (
            <div key={setting.key_id} className="setting-card">

              {/* Card header row */}
              <div style={styles.cardHeader}>
                <div style={{ flex: 1 }}>
                  <h3 style={styles.cardTitle}>{setting.key_description}</h3>
                  <p style={styles.cardSubtitle}>{setting.key_comments}</p>
                </div>
                {!isEditing(setting.key_id) && setting.edit_flag !== 0 && (
                  <span
                    onClick={() => handleEdit(setting)}
                    title={setting.edit_flag === 1 ? 'Edit setting' : 'Editing disabled'}
                    style={{ cursor: 'pointer', flexShrink: 0 }}
                  >
                    <img src={EditIcon} alt="Edit" />
                  </span>
                )}
              </div>

              {/* Body */}
              {!setting.has_sub_settings ? (

                /* Plain setting */
                isEditing(setting.key_id) ? (
                  <div style={styles.editContainer}>
                    <div style={styles.inlineEditRow}>
                      <div style={{ flex: 1 }}>
                        <label style={styles.label}>Value</label>
                        <input
                          type="text"
                          className="input-field"
                          value={editRows[0]?.value ?? ''}
                          onChange={e => handleRowChange(0, 'value', e.target.value)}
                          onBlur={() => {
                            if (!editRows[0]?.value?.trim()) setEditError('Value cannot be blank');
                          }}
                        />
                      </div>
                      <div style={{ flex: 2 }}>
                        <label style={styles.label}>Comments</label>
                        <input
                          type="text"
                          className="input-field"
                          value={editRows[0]?.comments_ ?? ''}
                          onChange={e => handleRowChange(0, 'comments_', e.target.value)}
                          placeholder="Add comments..."
                        />
                      </div>
                    </div>
                    {editError && <div style={styles.errorText}>{editError}</div>}
                    <div style={styles.buttonGroup}>
                      <button
                        className="create-test-section-btn"
                        style={styles.btn}
                        onClick={() => handleSave(setting)}
                        disabled={saving}
                      >
                        {saving ? 'SAVING...' : 'SAVE'}
                      </button>
                      <button
                        className="create-test-section-btn"
                        style={styles.btn}
                        onClick={handleCancelEdit}
                        disabled={saving}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={styles.valueDisplay}>
                    <span style={styles.valueLabel}>Value: </span>
                    {setting.value || <span style={styles.noValue}>Not set</span>}
                    {setting.comments_ && (
                      <span style={styles.commentsDisplay}> — {setting.comments_}</span>
                    )}
                  </div>
                )

              ) : (

                /* Sub settings — 4 column layout */
                <div>

                  {/* 4-column header */}
                  <div style={styles.subTableHeader}>
                    <span style={styles.colKey}>Key</span>
                    <span style={styles.colDescription}>Description</span>
                    <span style={styles.colValue}>Value</span>
                    <span style={styles.colComments}>Comments</span>
                  </div>

                  {setting.sub_settings.map(ss => (
                    <div key={ss.sub_key_id} style={styles.subRow}>

                      {/* Key column */}
                      <div style={styles.colKey}>
                        <span style={styles.subKeyDesc}>{ss.sub_key_description}</span>
                      </div>

                      {/* Description column */}
                      <div style={styles.colDescription}>
                        <span style={styles.subKeyComment}>{ss.sub_key_comments || '—'}</span>
                      </div>

                      {isEditing(setting.key_id) ? (
                        <>
                          {/* Value input */}
                          <div style={{ ...styles.colValue, paddingRight: '12px' }}>
                            <input
                              type="text"
                              className="input-field"
                              value={editRows[ss.sub_key_id]?.value ?? ''}
                              onChange={e => handleRowChange(ss.sub_key_id, 'value', e.target.value)}
                              onBlur={() => {
                                if (!editRows[ss.sub_key_id]?.value?.trim()) setEditError('Value cannot be blank');
                              }}
                            />
                          </div>
                          {/* Comments input */}
                          <div style={styles.colComments}>
                            <input
                              type="text"
                              className="input-field"
                              value={editRows[ss.sub_key_id]?.comments_ ?? ''}
                              onChange={e => handleRowChange(ss.sub_key_id, 'comments_', e.target.value)}
                              placeholder="Add comments..."
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Value display — truncated */}
                          <div style={styles.colValue}>
                            {ss.value
                              ? <span style={styles.valueText} title={ss.value}>{ss.value}</span>
                              : <span style={styles.noValue}>Not set</span>
                            }
                          </div>
                          {/* Comments display */}
                          <div style={styles.colComments}>
                            <span style={styles.commentsDisplay}>{ss.comments_ || '—'}</span>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {isEditing(setting.key_id) && (
                    <div style={{ marginTop: '12px' }}>
                      {editError && <div style={styles.errorText}>{editError}</div>}
                      <div style={styles.buttonGroup}>
                        <button
                          className="create-test-section-btn"
                          style={styles.btn}
                          onClick={() => handleSave(setting)}
                          disabled={saving}
                        >
                          {saving ? 'SAVING...' : 'SAVE'}
                        </button>
                        <button
                          className="create-test-section-btn"
                          style={styles.btn}
                          onClick={handleCancelEdit}
                          disabled={saving}
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Last modified footer */}
              {setting.last_modified_by && (
                <div style={styles.metadata}>
                  Last modified by {setting.last_modified_by} on {setting.last_modified_date}
                </div>
              )}

            </div>
          ))
        )}
      </div>
    </div>
  );
};

const css = `
  .tab-button-us {
    background: none;
    border: none;
    padding: 16px 8px;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.3s;
    color: #666;
  }
  .tab-button-us.active {
    color: #666;
    border-bottom-color: #ffbd20;
  }
  .tab-button-us:hover:not(.active) {
    color: #333;
  }
  .setting-card {
    background-color: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 16px;
  }
  .input-field {
    width: 100%;
    background-color: white;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    color: #1f2937;
    box-sizing: border-box;
  }
  .input-field:focus {
    outline: none;
    border-color: #f97316;
    box-shadow: 0 0 0 1px #f97316;
  }
`;

const styles = {
  container: { minHeight: '100vh', backgroundColor: 'white', color: '#1f2937', paddingLeft: '40px' },
  header: { borderBottom: '1px solid #d1d5db' },
  headerContent: { display: 'flex', gap: '32px' },
  content: { maxWidth: '1200px', paddingTop: '30px', paddingLeft: '20px' },
  emptyState: { textAlign: 'center', color: '#6b7280', padding: '48px 0' },
  cardHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '12px' },
  cardTitle: { fontSize: '18px', fontWeight: '500', color: '#1f2937', marginBottom: '4px' },
  cardSubtitle: { fontSize: '14px', color: '#6b7280', margin: 0 },
  editContainer: { display: 'flex', flexDirection: 'column', gap: '12px' },
  inlineEditRow: { display: 'flex', gap: '16px', alignItems: 'flex-end' },
  buttonGroup: { display: 'flex', gap: '12px', marginTop: '4px' },
  btn: { marginLeft: '0px', marginRight: '0px' },
  errorText: { color: '#b91c1c', fontSize: '13px', marginTop: '4px' },
  valueDisplay: { fontSize: '14px', color: '#374151' },
  valueLabel: { fontWeight: '500', fontSize: '14px', color: '#374151' },
  commentsDisplay: { fontSize: '13px', color: '#6b7280' },
  noValue: { color: '#9ca3af', fontStyle: 'italic', fontSize: '14px' },

  // 4-column layout — flex values control proportions
  subTableHeader: {
    display: 'flex',
    gap: '12px',
    padding: '6px 0',
    borderBottom: '1px solid #d1d5db',
    marginBottom: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#6b7280',
  },
  subRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    padding: '10px 0',
    borderBottom: '1px solid #e5e7eb',
  },
  colKey:         { flex: 1.5 },
  colDescription: { flex: 1.5 },
  colValue:       { flex: 2, minWidth: 0 },
  colComments:    { flex: 2 },

  subKeyDesc:    { fontSize: '14px', fontWeight: '500', color: '#1f2937' },
  subKeyComment: { fontSize: '13px', color: '#9ca3af' },

  valueText: {
    display: 'block',
    fontSize: '14px',
    color: '#374151',
    fontWeight: '500',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'default',
  },
  label: { fontSize: '13px', fontWeight: '500', color: '#374151', display: 'block', marginBottom: '4px' },
  metadata: {
    marginTop: '16px',
    paddingTop: '12px',
    borderTop: '1px solid #d1d5db',
    fontSize: '12px',
    color: '#6b7280',
  },
};

export default UserSettings;
